import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import Cookie from "js-cookie";
const userToken = Cookie.get("token");
const baseUrl = process.env.VUE_APP_BASE_API_URL;
Vue.use(VueAxios, axios);

Vue.use(axios);

const getNews = ({ commit, state }) => {
  return new Promise((resolve, reject) => {
    axios
      .get(baseUrl + "/news/member-news", {
        params: {
          search: state.search,
          page: state.page,
          page_size: state.page_size,
          order_by: "created_at",
          order_direction: "desc"
        },
        headers: {
          authorization: `Bearer ${userToken}`
        }
      })
      .then(
        response => {
          const res = response.data;
          resolve(response);
          if (res.data) {
            commit("SET_RESNEWS", res);
          }
        },
        error => {
          reject(error);
        }
      );
  });
};
const getMasterNews = ({ commit, state }) => {
  return new Promise((resolve, reject) => {
    axios
      .get(baseUrl + "/news/news", {
        params: {
          search: state.search,
          page: state.page,
          page_size: state.page_size,
          order_by: "created_at",
          order_direction: "desc"
        },
        headers: {
          authorization: `Bearer ${userToken}`
        }
      })
      .then(
        response => {
          const res = response.data;
          resolve(response);
          if (res.data) {
            commit("SET_RESMASTERNEWS", res);
          }
        },
        error => {
          reject(error);
        }
      );
  });
};
const getNewsDetail = ({ commit, state }) => {
  return new Promise((resolve, reject) => {
    axios
      .get(baseUrl + "/news/news/" + state.idNews, {
        headers: {
          authorization: `Bearer ${userToken}`
        }
      })
      .then(
        response => {
          const res = response.data;
          resolve(response);
          if (res.data) {
            commit("SET_RESNEWSDETAIL", res.data);
          }
        },
        error => {
          reject(error);
        }
      );
  });
};
const postCreateSlug = ({ state, commit }) => {
  return new Promise((resolve, reject) => {
    axios
      .post(baseUrl + "/news/slug-generator", state.nameSlug, {
        headers: {
          authorization: `Bearer ${userToken}`
        }
      })
      .then(
        response => {
          const ress = response.data;
          console.log(ress.data.slug);
          axios
            .post(
              baseUrl + "/news/slug-checker",
              { slug: ress.data.slug },
              {
                headers: {
                  authorization: `Bearer ${userToken}`
                }
              }
            )
            .then(
              response => {
                const res = response.data;
                resolve(response);
                commit("SET_RESSLUG", res.data);
              },
              error => {
                reject(error);
              }
            );
        },
        error => {
          reject(error);
        }
      );
  });
};
const postCreateNews = ({ state }) => {
  return new Promise((resolve, reject) => {
    axios
      .post(baseUrl + "/news/news", state.dataNews, {
        headers: {
          "Content-Type": "multipart/form-data",
          authorization: `Bearer ${userToken}`
        }
      })
      .then(
        response => {
          resolve(response);
        },
        error => {
          reject(error);
        }
      );
  });
};
const putNews = ({ state }) => {
  return new Promise((resolve, reject) => {
    axios
      .put(baseUrl + "/news/news/" + state.idNews, state.dataNews, {
        headers: {
          "Content-Type": "multipart/form-data",
          authorization: `Bearer ${userToken}`
        }
      })
      .then(
        response => {
          resolve(response);
        },
        error => {
          reject(error);
        }
      );
  });
};
const deleteNews = ({ state }) => {
  return new Promise((resolve, reject) => {
    axios
      .delete(baseUrl + "/news/news/" + state.idNews, {
        params: {
          forever: false
        },
        headers: {
          "Content-Type": "multipart/form-data",
          authorization: `Bearer ${userToken}`
        }
      })
      .then(
        response => {
          resolve(response);
        },
        error => {
          reject(error);
        }
      );
  });
};
export default {
  getNews,
  getNewsDetail,
  postCreateSlug,
  postCreateNews,
  deleteNews,
  putNews,
  getMasterNews
};
